var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path0, _g0, _path1, _g1, _path10, _g10, _path11, _g11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPipedrive = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 40,
    viewBox: "0 0 154 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_247_30945)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_247_30945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -13,
    y: -9,
    width: 178,
    height: 58
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.236 -8.92188H-12.7188V48.9738H164.236V-8.92188Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_247_30945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3196 11.1523C14.5334 11.1523 12.9179 12.3871 12.1453 13.2102C12.0517 12.4785 11.56 11.5411 9.64013 11.5411H5.44922V15.7941H7.15836C7.43932 15.7941 7.53297 15.8855 7.53297 16.1599V35.6185H12.4965V28.3473V27.7985C13.2691 28.4845 14.7441 29.4448 17.062 29.4448C21.9085 29.4448 25.3034 25.6949 25.3034 20.2986C25.3268 14.8337 22.0958 11.1523 17.3196 11.1523ZM16.3128 25.2147C13.6437 25.2147 12.4263 22.7223 12.4263 20.39C12.4263 16.7315 14.4632 15.4282 16.383 15.4282C18.7243 15.4282 20.3164 17.3947 20.3164 20.3443C20.293 23.7284 18.2795 25.2147 16.3128 25.2147Z",
    fill: "#203232"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_247_30945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -13,
    y: -9,
    width: 178,
    height: 58
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164.236 -8.92188H-12.7188V48.9738H164.236V-8.92188Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_247_30945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0004 24.4626V14.1502C32.0004 12.4124 31.1341 11.5664 29.3781 11.5664H24.9297V15.8194H26.6388C26.9198 15.8194 27.0134 15.9109 27.0134 16.1853V26.4519C27.0134 28.2126 27.8563 29.0357 29.6357 29.0357H34.0841V24.8056H32.375C32.1175 24.8285 32.0004 24.7141 32.0004 24.4626Z",
    fill: "#203232"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_247_30945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -13,
    y: -9,
    width: 178,
    height: 58
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M164.236 -8.92188H-12.7188V48.9738H164.236V-8.92188Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_247_30945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.97 11.1523C42.1838 11.1523 40.5683 12.3871 39.7723 13.2102C39.6786 12.4785 39.187 11.5411 37.2671 11.5411H33.0996V15.7941H34.8088C35.0897 15.7941 35.1834 15.8855 35.1834 16.1599V35.6185H40.1937V28.3473V27.7985C40.9663 28.4845 42.4648 29.4448 44.7592 29.4448C49.6057 29.4448 53.0006 25.6949 53.0006 20.2986C53.0006 14.8337 49.7696 11.1523 44.97 11.1523ZM43.9632 25.2147C41.2941 25.2147 40.0767 22.7223 40.0767 20.39C40.0767 16.7315 42.1136 15.4282 44.0334 15.4282C46.3747 15.4282 47.9668 17.3947 47.9668 20.3443C47.9668 23.7284 45.9533 25.2147 43.9632 25.2147Z",
    fill: "#203232"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_247_30945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -13,
    y: -9,
    width: 178,
    height: 58
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164.236 -8.92188H-12.7188V48.9738H164.236V-8.92188Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_247_30945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.344 11.1523C56.9824 11.1523 53.2598 14.9252 53.2598 20.2986C53.2598 25.6034 57.2868 29.4448 62.8591 29.4448C67.2373 29.4448 69.9064 26.9067 70.0234 26.8153L70.2341 26.6324L68.0801 23.1339L67.7524 23.4312C67.729 23.454 65.7623 25.2147 63.1634 25.2147C60.6817 25.2147 58.8555 23.7284 58.4106 21.3961H70.1873L70.2107 21.076C70.2107 21.0303 70.3278 20.0013 70.3278 19.4983C70.3278 14.5136 67.1202 11.1523 62.344 11.1523ZM58.5979 17.7834C59.1364 16.0684 60.4944 15.0852 62.344 15.0852C63.8424 15.0852 64.9896 16.2056 65.2004 17.7834H58.5979Z",
    fill: "#203232"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_247_30945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -13,
    y: -9,
    width: 178,
    height: 58
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M164.236 -8.92188H-12.7188V48.9738H164.236V-8.92188Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_247_30945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.4012 24.462V7.56428C88.4012 5.8265 87.5349 4.98047 85.7555 4.98047H81.3071V9.23347H83.0162C83.2972 9.23347 83.3908 9.32493 83.3908 9.59932V12.6633C82.665 12.0231 81.2368 11.177 78.7551 11.177C73.932 11.177 70.5605 14.9499 70.5605 20.3233C70.5605 25.7882 73.7915 29.4695 78.5678 29.4695C81.3071 29.4695 82.8992 28.2348 83.6718 27.3659C83.7654 28.1205 84.2805 29.0808 86.1301 29.0808H90.4381V24.8507H88.7758C88.4948 24.8278 88.4012 24.7135 88.4012 24.462ZM79.5277 25.2165C77.163 25.2165 75.6411 23.2958 75.6411 20.3004C75.6411 17.3965 77.2332 15.4529 79.5979 15.4529C82.2904 15.4529 83.4845 17.8767 83.4845 20.2776C83.4845 23.936 81.4475 25.2165 79.5277 25.2165Z",
    fill: "#203232"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_247_30945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -13,
    y: -9,
    width: 178,
    height: 58
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M164.236 -8.92188H-12.7188V48.9738H164.236V-8.92188Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_247_30945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.513 11.3125C99.4524 11.3125 97.5326 12.4786 96.4088 14.3308V13.942C96.4088 12.3643 95.5191 11.5412 93.7631 11.5412H89.502V15.7942H91.2111C91.492 15.7942 91.5857 15.8856 91.5857 16.16V29.0333H96.5492V22.0365C96.5492 21.1218 96.6663 20.2301 96.9004 19.4069C97.6496 16.9832 99.6397 16.1371 101.232 16.1371C101.794 16.1371 102.215 16.2057 102.215 16.2057L102.637 16.2743V11.4497L102.332 11.404C102.332 11.3811 101.911 11.3125 101.513 11.3125Z",
    fill: "#203232"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_247_30945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -13,
    y: -9,
    width: 178,
    height: 58
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M164.236 -8.92188H-12.7188V48.9738H164.236V-8.92188Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_247_30945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.708 24.4626V14.1502C109.708 12.4124 108.842 11.5664 107.086 11.5664H103.059V15.8194H104.346C104.627 15.8194 104.721 15.9109 104.721 16.1853V26.4519C104.721 28.2126 105.564 29.0357 107.343 29.0357H111.792V24.8056H110.082C109.825 24.8285 109.708 24.7141 109.708 24.4626Z",
    fill: "#203232"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_247_30945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -13,
    y: -9,
    width: 178,
    height: 58
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M164.236 -8.92188H-12.7188V48.9738H164.236V-8.92188Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_247_30945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.461 11.5664H125.816C124.27 11.5664 123.427 12.0923 122.936 13.3728L119.705 22.1989C119.588 22.519 119.494 22.8849 119.4 23.2507C119.307 22.9077 119.19 22.519 119.073 22.1989L115.842 13.3728C115.35 12.0694 114.554 11.5664 112.962 11.5664H110.152V15.8194H110.878C111.276 15.8194 111.393 15.9566 111.487 16.1853L116.497 29.0586H122.093L127.103 16.1853C127.197 15.9566 127.314 15.8194 127.712 15.8194H128.485V11.5664H128.461Z",
    fill: "#203232"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_247_30945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -13,
    y: -9,
    width: 178,
    height: 58
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M164.236 -8.92188H-12.7188V48.9738H164.236V-8.92188Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_247_30945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.03 11.1523C131.668 11.1523 127.945 14.9252 127.945 20.2986C127.945 25.6034 131.972 29.4448 137.545 29.4448C141.923 29.4448 144.592 26.9067 144.709 26.8153L144.92 26.6324L142.766 23.1339L142.438 23.4312C142.415 23.454 140.448 25.2147 137.872 25.2147C135.391 25.2147 133.564 23.7284 133.12 21.3961H144.896L144.92 21.076C144.92 21.0303 145.013 20.0013 145.013 19.4983C145.013 14.5136 141.806 11.1523 137.03 11.1523ZM133.283 17.7834C133.822 16.0684 135.18 15.0852 137.03 15.0852C138.528 15.0852 139.675 16.2056 139.886 17.7834H133.283Z",
    fill: "#203232"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_247_30945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -13,
    y: -9,
    width: 178,
    height: 58
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M164.236 -8.92188H-12.7188V48.9738H164.236V-8.92188Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_247_30945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6496 4.95703H27.2246V9.50729H31.6496V4.95703Z",
    fill: "#203232"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_247_30945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -13,
    y: -9,
    width: 178,
    height: 58
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M164.236 -8.92188H-12.7188V48.9738H164.236V-8.92188Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_247_30945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.38 4.95703H104.955V9.50729H109.38V4.95703Z",
    fill: "#203232"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_247_30945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -13,
    y: -9,
    width: 178,
    height: 58
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M164.236 -8.92188H-12.7188V48.9738H164.236V-8.92188Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_247_30945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.92 11.5639H145.575V13.3017H146.067V11.5639H146.723V11.1523H144.92V11.5639Z",
    fill: "#203232"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_247_30945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -13,
    y: -9,
    width: 178,
    height: 58
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M164.236 -8.92188H-12.7188V48.9738H164.236V-8.92188Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_247_30945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.666 11.1523L148.175 12.6386L147.659 11.1523H146.98V13.3017H147.425V11.7926H147.449L147.987 13.3017H148.362L148.9 11.7926V13.3017H149.345V11.1523H148.666Z",
    fill: "#203232"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_247_30945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 154,
    height: 40,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPipedrive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Pipedrive.c8df8677eb3e622082424b349f06418e.svg";